import { useTranslation } from "next-i18next";

const COMPACT_LOAD_POSTING_NAMESPACES = ["load-form", "homepageV2", "common"] as const;

export const useCompactLoadPostingTranslation = () => {
    const { t, i18n } = useTranslation(COMPACT_LOAD_POSTING_NAMESPACES);

    return { t, i18n };
};

export default useCompactLoadPostingTranslation;
